function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useController, RhfFieldError, rhfMapperReq } from '@isyc-react/form/modules/rhf';
import { InputDropFile } from "./input-drop-file.component";
import { InputDropMultiFile } from "./input-drop-multi-file.component";
const requiredFileValue = v => {
  var _v$api;
  return Boolean((_v$api = v.api) === null || _v$api === void 0 ? void 0 : _v$api.id) || Boolean(v.file);
};
export const RhfInputDropFile = props => {
  const {
    rhf,
    errorMessage,
    input
  } = props;
  const {
    field: {
      onChange,
      onBlur,
      name,
      value,
      ref
    },
    fieldState: {
      error
    }
  } = useController(rhfMapperReq(rhf, v => {
    return v.accepted ? requiredFileValue(v.accepted) : false;
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputDropFile, _extends({
    onChange: onChange,
    onBlur: onBlur,
    value: value,
    error: Boolean(error)
  }, input)), /*#__PURE__*/React.createElement(RhfFieldError, {
    errorMessage: errorMessage,
    error: error
  }));
};
export const RhfInputDropMultiFile = props => {
  const {
    rhf,
    errorMessage,
    input
  } = props;
  const {
    field: {
      onChange,
      onBlur,
      name,
      value,
      ref
    },
    fieldState: {
      error
    }
  } = useController(rhfMapperReq(rhf, v => {
    return v.accepted.length > 0 && v.accepted.some(requiredFileValue);
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputDropMultiFile, _extends({
    onChange: onChange,
    onBlur: onBlur,
    value: value,
    error: Boolean(error)
  }, input)), /*#__PURE__*/React.createElement(RhfFieldError, {
    errorMessage: errorMessage,
    error: error
  }));
};